import { Phone, PhoneIncoming, PhoneOutgoing, PhoneMissed } from "lucide-react";

const sampleCalls = [
  { type:"outgoing", name:"John Smith", duration:"3:22", time:"Today 10:45am", outcome:"Positive" },
  { type:"incoming", name:"Maria Garcia", duration:"1:05", time:"Today 9:12am", outcome:"Neutral" },
  { type:"missed", name:"Unknown", duration:"—", time:"Yesterday 4:30pm", outcome:"No Answer" },
];

export default function Calls() {
  return (
    <div className="page">
      <div className="page-header">
        <div>
          <div className="page-title">Calls</div>
          <div className="page-subtitle">Twilio integration — connect your Cloudflare Worker to enable calling.</div>
        </div>
        <button className="btn btn-primary" disabled>📞 New Call</button>
      </div>

      <div className="placeholder-box" style={{ marginBottom: 24 }}>
        <div className="placeholder-icon blue">📞</div>
        <div className="placeholder-title">Twilio Integration Pending</div>
        <p className="placeholder-desc">Connect your Cloudflare Worker with Twilio credentials to enable outbound/inbound calling, call recording, and automatic lead logging.</p>
        <span className="badge badge-outline">Configure via Cloudflare Worker</span>
      </div>

      <div className="card">
        <div className="card-header"><span className="card-title">Call Log</span></div>
        <div className="card-body">
          {sampleCalls.map((call, i) => (
            <div key={i} className="call-item">
              <div className={`call-icon ${call.type === "missed" ? "red" : "green"}`}>
                {call.type === "incoming" && <PhoneIncoming size={16} color="#16a34a" />}
                {call.type === "outgoing" && <PhoneOutgoing size={16} color="#16a34a" />}
                {call.type === "missed" && <PhoneMissed size={16} color="#dc2626" />}
              </div>
              <div className="call-info">
                <strong>{call.name}</strong>
                <span>{call.time}</span>
              </div>
              <span className="call-duration">{call.duration}</span>
              <span className="badge badge-outline">{call.outcome}</span>
            </div>
          ))}
          <p style={{ marginTop: 12, fontSize: 12, color: "#94a3b8", textAlign: "center" }}>Sample data — real calls will appear here once Twilio is connected.</p>
        </div>
      </div>
    </div>
  );
}